import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

export interface StepDefinition {
  label: string;
  icon?: string;
  statusBadge?: () => string;
  action: () => Promise<void> | void;
  isDone: () => boolean;
}

@Component({
  selector: 'app-step-progress-runner',
  templateUrl: './step-progress-runner.component.html',
  styleUrls: ['./step-progress-runner.component.css'],
})
export class StepProgressRunnerComponent implements OnInit, OnDestroy {
  emojis = [
  '🚀', '💡', '🧠', '🎨', '✨', '📝', '✍️', '📚', '📄', '🗒️',
  '📊', '📈', '💼', '💰', '🎯', '🔍', '🧭', '📋', '🧩', '🤝',
  '🎉', '✅', '⏳', '🏆', '🔥', '🌈', '💭', '💬', '📅', '📌'
];

  @Input() steps: StepDefinition[] = [];
  @Input() validationIntervalMs = 2000;
  @Input() maxAttempts = 50;

  @Output() onStepChange = new EventEmitter<number>();
  @Output() onStepStart = new EventEmitter<number>();
  @Output() onStepDone = new EventEmitter<number>();
  @Output() onAllDone = new EventEmitter<void>();

  currentStep = 0;
  isProcessing = false;
  isComplete = false;
  validationInterval: any;

  ngOnInit() {
    if (this.steps.length > 0) {
      this.runCurrentStep();
    }
  }

  ngOnDestroy() {
    if (this.validationInterval) clearInterval(this.validationInterval);
  }



  private async runCurrentStep(): Promise<void> {
    if (this.currentStep >= this.steps.length) {
      this.completeAll();
      return;
    }

    const step = this.steps[this.currentStep];

    this.isProcessing = true;
    this.onStepStart.emit(this.currentStep);

    try {
      await Promise.resolve(step.action());
      this.startValidationPolling(step);
    } catch (err) {
      console.error(`Error executing step "${step.label}"`, err);
      this.isProcessing = false;
    }
  }

  private startValidationPolling(step: StepDefinition): void {
    let attempts = 0;
    if (this.validationInterval) clearInterval(this.validationInterval);

    this.validationInterval = setInterval(() => {
      attempts++;
      const done = step.isDone();

      if (done) {
        clearInterval(this.validationInterval);
        this.validationInterval = null;
        this.isProcessing = false;

        this.onStepDone.emit(this.currentStep);

        setTimeout(() => {
          this.currentStep++;
          this.onStepChange.emit(this.currentStep);
          this.runCurrentStep();
        }, 1200); // smooth delay
      } else if (attempts >= this.maxAttempts) {
        console.warn(`Validation for step "${step.label}" timed out.`);
        clearInterval(this.validationInterval);
        this.isProcessing = false;
      }
    }, this.validationIntervalMs);
  }

  private completeAll(): void {
    this.isComplete = true;
    this.onAllDone.emit();
  }
}
